import { DocumentsUpload } from './documents-upload.interface';
import { ProgramList } from './program-list';
import { AishIncomeTypes } from './aish-income-types';
import { AishAssetTypes } from './aish-asset-types';
import { AishAdditionalAssetTypes } from './aish-additional-asset-types';

const diaName = ProgramList.dia;

const ResidencyDocs = [
  "Current driver's licence",
  'Government issued identification card (ex. Alberta ID card)',
  'Rent receipt',
  'Utility bill',
  'Letter from facility/institution',
  'Letter from shelter',
  'Letter from community agency',
];

const IdentificationDocs = [
  "Driver's licence",
  'Government issued identification card (ex. Alberta ID card)',
  'Birth, marriage or baptismal certificate',
  'Employee or student card',
  'Band registry number, status card, or Metis card',
  'Alberta Personal Health Card',
  'Social Insurance Number',
];
const IdentificationDocsParter = [...IdentificationDocs, 'Statutory declaration'];

const ResidencyDocsPartner = [...ResidencyDocs, 'Statutory declaration'];

//map income/asset types to corresponding document types
const IncomeDocumentCategories = Object.fromEntries(
  Object.entries(AishIncomeTypes).map(([key, income]) => [
    key,
    {
      displayValue: income.displayValue,
      documentTypes: income.documentTypes,
      categoryTitleOverride: income.categoryTitleOverride,
      order: income.order,
      hideCategoryLabel: false,
    },
  ])
);

const AssetsDocumentCategories = Object.fromEntries(
  Object.entries(AishAssetTypes).map(([key, asset]) => [
    key,
    {
      displayValue: asset.displayValue,
      documentTypes: asset.documentTypes,
      categoryTitleOverride: asset.categoryTitleOverride,
      order: asset.order,
      hideCategoryLabel: false,
    },
  ])
);

const AdditionalAssetsDocumentCategories = Object.fromEntries(
  Object.entries(AishAdditionalAssetTypes).map(([key, asset]) => [
    key,
    {
      displayValue: asset.displayValue,
      documentTypes: asset.documentTypes,
      categoryTitleOverride: asset.categoryTitleOverride,
      order: asset.order,
      hideCategoryLabel: false,
    },
  ])
);

export const AishDocumentCategories: { [name: string]: DocumentsUpload } = {
  relation: {
    identification: {
      displayValue: 'Identification',
      documentTypes: [`Trustee/Power of Attorney`],
      categoryTitleOverride: `Trustee/Power of Attorney document`,
      requiredErrorOverride: `Trustee/Power of Attorney documents are required.`,
      hideDocumentTypeLabel: true,
    },
    identificationUnder18: {
      //only used to transform the labels
      displayValue: 'Identification',
      documentTypes: [`Legal Guardian/Trustee`],
      categoryTitleOverride: `Legal Guardian/Trustee document`,
      requiredErrorOverride: `Legal Guardian/Trustee documents are required.`,
      hideDocumentTypeLabel: true,
    },
  },
  personalInformation: {
    residency: {
      displayValue: 'Where you live',
      documentTypes: [...ResidencyDocs],
      order: 1,
    },
    residencyPartner: {
      displayValue: 'Where you live',
      documentTypes: [...ResidencyDocsPartner],
      order: 1,
    },
    permResidency: {
      displayValue: 'Permanent Residency',
      documentTypes: ['Confirmation of permanent residence ', 'Permanent resident card', 'Record of landing'],
      categoryTitleOverride:
        'Proof of permanent residence (include an image of both the front and back of the residency card)',
    },
    identification: {
      displayValue: 'Identification',
      documentTypes: [...IdentificationDocs],
    },
    identificationPartner: {
      displayValue: 'Identification',
      documentTypes: [...IdentificationDocsParter],
    },
  },
  dependents: {
    identification: {
      displayValue: 'Identification',
      documentTypes: [
        "Driver's licence",
        'Government issued identification card (ex. Alberta ID card)',
        'Birth, marriage or baptismal certificate',
        'Employee or student card',
        'Band registry number, status card, or Metis card',
        'Alberta Personal Health Card',
        'Social Insurance Number',
      ],
      order: 0,
    },
    highSchoolDeclaration: {
      displayValue: 'High school Declaration',
      documentTypes: ['Declaration of 18-19 Year Old Dependent Child'],
      order: 1,
      categoryTitleOverride: 'Declaration of 18-19 Year Old Dependent Child',
      hideDocumentTypeLabel: true,
    },
  },
  medical: {
    medicalReport: {
      displayValue: `${diaName.abbreviation} Medical report`,
      categoryTitleOverride: `Copy of ${diaName.abbreviation} Medical report`,
      documentTypes: [`${diaName.abbreviation} Medical report`, 'Other medical document'],
    },
    medicalLetter: {
      displayValue: 'Medical letter',
      documentTypes: ['Medical letter', 'Other medical document'],
    },
    otherMedicalDocument: {
      displayValue: 'Other medical document',
      documentTypes: ['Other medical document'],
    },
  },
  incomes: {
    ...IncomeDocumentCategories,
  },
  assets: {
    ...AssetsDocumentCategories,
  },
  additionalAssets: {
    ...AdditionalAssetsDocumentCategories,
  },
  consent: {
    consentDocument: {
      displayValue: 'Consent and declaration',
      documentTypes: ['Consent document'],
      categoryTitleOverride: 'Consent and Declaration',
      hideDocumentTypeLabel: true,
    },
  },

  spousePartner: {
    identification: {
      displayValue: 'Identification',
      documentTypes: [
        "Driver's licence",
        'Government issued identification card (ex. Alberta ID card)',
        'Birth, marriage or baptismal certificate',
        'Employee or student card',
        'Band registry number, status card, or Metis card',
        'Alberta Personal Health Card',
        'Social Insurance Number',
      ],
    },
  },
  trusteeAttorney: {
    identification: {
      // displayValue: 'Trustee/Attorney',
      displayValue: 'Identification',
      documentTypes: ['Trustee/Attorney Document'],
      categoryTitleOverride: 'Trustee/Attorney Document',
      hideDocumentTypeLabel: true,
    },
  },

  signature: {
    spouseConsentDocument: {
      code: 'spouseConsentDocument',
      displayValue: 'CRA Consent and CPP-D Consent',
      documentTypes: ['CRA Consent and CPP-D Consent'],
      categoryTitleOverride: 'CRA Consent and CPP-D Consent',
      requiredErrorOverride: 'CRA Consent and CPP-D Consent is required',
      order: 1,
    },
  },
  signatureRequest: {
    spouseCraConsent: {
      code: 'spouseCraConsent',
      displayValue: 'CRA Consent',
      documentTypes: ['CRA Consent'],
      categoryTitleOverride: 'CRA Consent',
      requiredErrorOverride: 'CRA Consent is required',
    },
  },
};
